import {FC} from 'react';
import {isMobile} from 'react-device-detect';

import {Button} from '@zoefin/design-system/v2';

import {getControlsClassName} from '../../utils';
import LayoutBackButtons from '../LayoutBackButtons';

import {LayoutControlsProps} from './types';

import styles from '../../styles.module.scss';

const LayoutControls: FC<LayoutControlsProps> = ({
  currentStep,
  continueButton,
  continueBtnLabel,
  ui,
  isAboutStep,
  prev,
  next,
}) => (
  <>
    {currentStep !== 'animation' && (
      <div className={getControlsClassName(continueButton.isVisible, ui)}>
        {continueButton.isVisible && (
          <div className={styles.stepWrapper__controls_continue}>
            <Button
              className={styles.stepWrapper__controls_continue__button}
              disabled={!continueButton.isValid}
              onClick={isMobile ? undefined : next}
              onTouchEnd={isMobile ? next : undefined}
              config={{
                icon: {
                  name: 'fa-regular fa-arrow-right',
                  position: 'right',
                },
              }}
              fullWidth
              as="button">
              {continueBtnLabel}
            </Button>
          </div>
        )}

        {isAboutStep && (
          <p className={styles.stepWrapper__controls_disclosures}>
            By sharing your e-mail address above and clicking the button below,
            you consent to the electronic delivery of Zoe Financial’s Form&nbsp;
            <a
              href="https://findanadvisor.com/legal/form-adv-part-2a"
              target="_blank"
              rel="noreferrer">
              ADV 2A
            </a>
            , Form&nbsp;
            <a
              href="https://findanadvisor.com/legal/zoe-financial-inc-customer-relationship-summary"
              target="_blank"
              rel="noreferrer">
              CRS
            </a>
            , and&nbsp;
            <a
              href="https://findanadvisor.com/solicitation-disclosures"
              target="_blank"
              rel="noreferrer">
              Solicitor’s Disclosure
            </a>
            .
          </p>
        )}

        <LayoutBackButtons
          show={ui?.hideBackButton !== true}
          isAboutStep={isAboutStep}
          ui={ui}
          prev={prev}
        />
      </div>
    )}

    {isAboutStep && (
      <Button
        as="button"
        className={styles.stepWrapper__controls_aboutBack}
        config={{type: 'secondary'}}
        onClick={() => prev()}>
        Go Back
      </Button>
    )}
  </>
);

export default LayoutControls;
